import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

const useStyles = makeStyles((_theme) => ({
  dashedBox: {
    marginTop: 10,
    marginBottom: 10,
    padding: 20,
    borderStyle: "dashed",
    borderRadius: 1,
    borderWidth: 3,
    borderColor: "#d3d3d3",
    textAlign: "center",
  },
}));

function EmptyClientList({ isCompany, partners, isWanted, onCreateClient, onContactDeutsche, isSoleTraderFeature }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.dashedBox}>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        {!isWanted ? (
          <>
            <Grid item xs>
              <ArrowUpwardIcon />
            </Grid>
            <Grid item xs>
              <Typography>{t("Client.GeneralSearchMessage")}</Typography>
            </Grid>
          </>
        ) : (!isCompany || isSoleTraderFeature) && isWanted && partners.length > 0 ? (
          <Grid item xs={12}>
            <Typography>{t("Client.Found")}</Typography>
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography>{t("Client.NotFound")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>{t("Client.NoClientsFoundForParameters")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>{t("Client.OR")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Button id="clientSearch_newClient" variant="contained" color="primary" onClick={onCreateClient}>
                {t("Client.CreateClient")}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Typography>{t("Client.OR")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Button id="clientSearch_contact" variant="contained" color="primary" onClick={onContactDeutsche}>
                {t("Client.ContactDeutsche")}
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}

EmptyClientList.propTypes = {
  isCompany: PropTypes.bool.isRequired,
  partners: PropTypes.array.isRequired,
  isWanted: PropTypes.bool.isRequired,
  onCreateClient: PropTypes.func.isRequired,
  onContactDeutsche: PropTypes.func.isRequired,
  isSoleTraderFeature: PropTypes.bool.isRequired,
};

export default EmptyClientList;
